import sessionGuard from '@/service/sessionGuard';

let activeOperations = 0;

export function beginSessionProtection(): () => void {
    activeOperations += 1;
    sessionGuard.touch();
    let finished = false;

    return () => {
        if (finished) {
            return;
        }
        finished = true;
        activeOperations = Math.max(0, activeOperations - 1);
        sessionGuard.touch();
    };
}

export async function withSessionProtection<T>(operation: () => Promise<T>): Promise<T> {
    const finish = beginSessionProtection();
    try {
        return await operation();
    } finally {
        finish();
    }
}

export function hasSessionProtection(): boolean {
    return activeOperations > 0;
}
